import React from 'react';
import { beautifyNumber } from '../../../Utils/FormatNumber';
import { VAT_COLUMNS } from './yearlyVatReportUtils';

const Amount = ({ value }) => {
    const number = Number(value) || 0;
    const className = number === 0
        ? 'yvr__value--zero'
        : number < 0
            ? 'yvr__value--negative'
            : '';

    return <span className={className}>{beautifyNumber(number, 0, true)}</span>;
};

const ValuesRow = ({ label, values, rowClassName }) => (
    <tr className={rowClassName}>
        <td className="yvr__row-label">{label}</td>
        {VAT_COLUMNS.map((column) => (
            <td key={column.key}>
                <Amount value={values?.[column.key]} />
            </td>
        ))}
    </tr>
);

/**
 * The on-screen twin of the server-rendered comparative VAT report: three rows per period
 * (computed / reported / difference) followed by the yearly totals.
 */
const YearlyVatComparisonTable = ({ t, data }) => {
    const periods = data?.periods ?? [];

    return (
        <div className="yvr__table-wrapper">
            <table className="yvr__table">
                <thead>
                    <tr>
                        <th>{t('Period')}</th>
                        {VAT_COLUMNS.map((column) => (
                            <th key={column.key}>{t(column.labelKey)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {periods.map((period) => (
                        <React.Fragment key={period.periodKey}>
                            <ValuesRow
                                label={`${t('VatRowCalculated')} ${period.periodKey}`}
                                values={period.calculated}
                                rowClassName={`yvr__row--calculated ${period.isReported ? '' : 'yvr__row--unreported'}`}
                            />
                            <ValuesRow
                                label={`${t('VatRowReported')} ${period.periodKey}`}
                                values={period.reported}
                                rowClassName="yvr__row--reported"
                            />
                            <ValuesRow
                                label={t('Difference')}
                                values={period.difference}
                                rowClassName="yvr__row--difference yvr__row--period-end"
                            />
                        </React.Fragment>
                    ))}

                    <ValuesRow
                        label={t('TotalCalculated')}
                        values={data?.totalCalculated}
                        rowClassName="yvr__row--total"
                    />
                    <ValuesRow
                        label={t('TotalReported')}
                        values={data?.totalReported}
                        rowClassName="yvr__row--total"
                    />
                    <ValuesRow
                        label={t('TotalDifferences')}
                        values={data?.totalDifference}
                        rowClassName="yvr__row--total"
                    />
                </tbody>
            </table>
        </div>
    );
};

export default YearlyVatComparisonTable;
